<script lang="ts">
	import ComponentCover from "../common/ComponentCover.svelte";
	import StoreIMG from "@hitit/hub/src/assets/place/placewelcome.png";
	import { getPostWord } from "../../../utils/string";
	import { api, t } from "../../../stores";
	import type { storeStatus } from "@hitit/api";
	export let editmode = false;
	export let storename = "";
	export let storeId = "";

	$: storeStatusPromise = ((storeId: string) => {
		return $api.getStoreStatus(storeId);
	})(storeId);
	// Place is only serviced in Korea
	// Except for input information, use only Korean
	const translatedStoreStatus = (status: storeStatus) =>
		$t(`hub.place.status.${status}`);

</script>

<div class="container">
	<img src={StoreIMG} alt="WelcomImage" id="welcome-image" />
	<p class="welcome">어서오세요</p>
	<h1 class="store-status">
		{storename}
		<span class="regular">{getPostWord(storename, '은', '는')}</span>
		{#await storeStatusPromise}
			<span class="status">...</span>
		{:then statusResponse}
			<span
				class="status"
				class:close={statusResponse.data.storeStatus.storeStatus !== 'OPEN'}>
				{translatedStoreStatus(statusResponse.data.storeStatus.storeStatus)}
			</span>
		{/await}
		<span class="regular">입니다.</span>
	</h1>
	<div class="seperate-bar" />
	{#if editmode}
		<ComponentCover coverColor={'rgba(255,255,255,0.6)'} />
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";
	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		position: relative;

		#welcome-image {
			width: 33.2px;
			height: 39.5px;
			object-fit: contain;
			margin-top: 3px;
		}

		p.welcome {
			color: #46474b;
			margin-top: 12.3px;
		}

		.store-status {
			margin-top: 5px;
			font-size: 1.5rem;
			font-weight: 600;
			color: #46474b;
			word-spacing: 0 !important;
			word-break: break-all;
			padding: 0px 10px;
			text-align: center;
			.regular {
				font-weight: 400;
				margin-left: -5px;
			}

			.status {
				color: #6591fa;
				&.close {
					color: #f36464;
				}
			}
		}

		.seperate-bar {
			width: 21px;
			height: 1px;
			background-color: #bcbfc3;
			margin-top: 20px;
		}
	}

	@include DesktopSize {
		.container {
			#welcome-image {
				width: 60.2px;
				height: 71.2px;
			}

			p.welcome {
				font-size: 1.75rem;
				margin-top: 21px;
			}

			.store-status {
				padding: 0px;
				font-size: 2.5rem;
				margin-top: 12px;

				.regular {
					margin-left: -10px;
				}
			}
		}
	}

</style>
